import React, { PureComponent } from 'react';
import { Header } from 'semantic-ui-react';
import Attribute from '../Attributes';

import './AttributeGroup.css';

export default class AttributeGroup extends PureComponent {
  render() {
    const { groupName, appApi } = this.props;
    const {
      label,
      preDescription,
      postDescription,
      attributes,
    } = appApi.config.getAttributeGroup(groupName);

    return (
      <div className="attributeGroup">
        {label && (
          <Header className="header" as="h2">
            {label}
          </Header>
        )}
        {preDescription && <p>{preDescription}</p>}
        {attributes.map(attributeName => (
          <Attribute
            key={attributeName}
            attributeName={attributeName}
            {...this.props}
          />
        ))}
        {postDescription && (
          <p className="postDescription">{postDescription}</p>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AttributeGroup/index.js